import { render, staticRenderFns } from "./HighlightStats.vue?vue&type=template&id=64291540&scoped=true"
import script from "./HighlightStats.vue?vue&type=script&lang=js"
export * from "./HighlightStats.vue?vue&type=script&lang=js"
import style0 from "./HighlightStats.vue?vue&type=style&index=0&id=64291540&prod&lang=css"
import style1 from "./HighlightStats.vue?vue&type=style&index=1&id=64291540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64291540",
  null
  
)

export default component.exports